<template>
  <v-card
    flat
    outlined
    rounded="lg"
    height="100%"
    color="cardbg"
    class="flex"
    elevation="10"
  >
    <v-card-title
      :style="`padding: calc(${scale} * 0.4rem);
        line-height: calc(${scale} * 0.75rem);
        font-size: calc(${scale} * 0.7rem);`"
      class="font-weight-medium d-flex justify-space-between"
    >
      <span class="titlecolor--text">
        {{ title }}
      </span>
      <span class="subtitlecolor--text">{{ daterange }}</span>
    </v-card-title>
    <v-card-text
      :style="`padding: calc(${scale} * 0.25rem);`"
      style="height: 90%; line-height: normal;"
    >
      <WidgetLoading v-if="loading" />
      <highcharts
        v-else
        :options="options"
        style="height: 100%; width: 100%;"
        :key="uuid"
      ></highcharts>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import WidgetLoading from './WidgetLoading.vue';

export default {
  name: 'LineChart',
  props: {
    title: { type: String },
    daterange: { type: String },
    scale: { type: Number, default: 1 },
    unit: { type: String },
    loading: { type: Boolean, default: false },
  },
  components: {
    WidgetLoading,
  },
  data() {
    return {
      uuid: 'uuid',
      options: {
        chart: {
          type: 'line',
          backgroundColor: 'transparent',
          style: {
            fontFamily: 'Poppins, "Open Sans", sans-serif',
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              style: {
                textOutline: 'none',
              },
            },
          },
          series: {
            lineWidth: 4,
            color: '#040D14',
            marker: {
              radius: 4,
            },
          },
        },
        title: { text: '' },
        xAxis: {
          categories: [],
          labels: {},
          type: 'category',
          crosshair: true,
          title: { text: '' },
        },
        yAxis: {
          min: 0,
          max: 100,
          title: { text: '' },
          labels: {},
          gridLineColor: 'transparent',
          plotBands: [],
        },
        legend: {
          enabled: false,
        },
        series: [],
      },
    };
  },
  computed: {
    ...mapState('cellwiseProductionDashboard', ['theme']),
    ...mapGetters('cellwiseProductionDashboard', ['activeTheme']),
  },
  watch: {
    scale(val) {
      this.adjustSize(val);
      this.createUUID();
    },
    activeTheme() {
      this.applyTheme();
      this.createUUID();
    },
  },
  mounted() {
    this.applyTheme();
  },
  methods: {
    assignData(result) {
      this.options.xAxis.categories = result.categories;
      this.options.series = result.series;
      this.options.yAxis.plotBands = result.plotBands;
      this.adjustSize(this.scale);
      this.applyTheme();
      this.createUUID();
    },
    applyTheme() {
      const themes = this.theme && this.theme.themes;
      const currentTheme = themes && themes[this.activeTheme]
        ? themes[this.activeTheme]
        : { subtitlecolor: '#A1A3A5', titlecolor: '#FFFFFF' };

      const plotOpts = this.options.plotOptions;
      if (plotOpts && plotOpts.line && plotOpts.line.dataLabels) {
        plotOpts.line.dataLabels.style = {
          ...plotOpts.line.dataLabels.style,
          color: currentTheme.titlecolor,
          textOutline: 'none',
          fontFamily: 'Poppins, "Open Sans", sans-serif',
        };
      }

      if (this.options.xAxis.labels) {
        this.options.xAxis.labels.style = {
          ...this.options.xAxis.labels.style,
          color: currentTheme.subtitlecolor,
          fontFamily: 'Poppins, "Open Sans", sans-serif',
        };
      }
      if (this.options.yAxis.labels) {
        this.options.yAxis.labels.style = {
          ...this.options.yAxis.labels.style,
          color: currentTheme.subtitlecolor,
          fontFamily: 'Poppins, "Open Sans", sans-serif',
        };
      }

      const seriesColor = this.activeTheme === 'dark' ? '#FFFFFF' : '#040D14';
      this.options.plotOptions.series.color = seriesColor;
    },
    adjustSize(scale) {
      const lablesize = 9 * scale;
      const padding = 15 * scale;

      if (this.options.xAxis.labels) {
        this.options.xAxis.labels.y = padding;
        this.options.xAxis.labels.reserveSpace = true;
        this.options.xAxis.labels.style = {
          ...this.options.xAxis.labels.style,
          fontSize: `${lablesize}px`,
        };
      }
      if (this.options.yAxis.labels) {
        this.options.yAxis.labels.style = {
          ...this.options.yAxis.labels.style,
          fontSize: `${lablesize}px`,
        };
      }

      if (this.options.plotOptions.line.dataLabels) {
        this.options.plotOptions.line.dataLabels.style = {
          ...this.options.plotOptions.line.dataLabels.style,
          fontSize: `${lablesize}px`,
          fontFamily: 'Poppins, "Open Sans", sans-serif',
        };
      }
    },
    createUUID() {
      let dt = new Date().getTime();
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // eslint-disable-next-line
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        // eslint-disable-next-line
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
      });
      this.uuid = uuid;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-full {
  width: 100%;
}
.h-full {
  height: 100%;
}
</style>
